/**
 * Linear interpolate between two values.
 *
 * @param {number} a The first value.
 * @param {number} b The second value.
 * @param {number} t The percentage of interpolation, between 0 and 1.
 */
export function lerp(a, b, t) {
    return a + t * (b - a);
}
